export const FAQ_CATEGORIES = [
  "Finanza agevolata",
  "Avvio impresa",
  "Finanza e controllo",
  "Persone e lavoro",
  "Marketing",
  "Metodo",
];

export const FAQS = [
  {
    slug: "contributi-fondo-perduto-pmi-campania",
    category: "Finanza agevolata",
    q: "Quali contributi a fondo perduto possono ottenere le PMI in Campania?",
    a: "Le PMI campane possono accedere a contributi a fondo perduto e finanziamenti agevolati tramite bandi regionali gestiti da Sviluppo Campania e dal portale SURAP, misure nazionali di Invitalia e agevolazioni per il Mezzogiorno come la ZES Unica. L'entità del contributo dipende da dimensione d'impresa, codice ATECO, zona e tipo di investimento.",
    detail: [
      "I canali principali sono tre: i bandi della Regione Campania (spesso a sportello, quindi con risorse che si esauriscono in fretta), gli incentivi nazionali di Invitalia e del MIMIT applicabili al Mezzogiorno, e i crediti d'imposta automatici legati agli investimenti.",
      "Il lavoro che facciamo prima di candidarti è sempre lo stesso: verifichiamo requisiti e codice ATECO, quantifichiamo l'investimento ammissibile, costruiamo il piano economico e prepariamo la documentazione. Poi gestiamo l'invio e, soprattutto, la rendicontazione: è lì che si perdono più contributi.",
    ],
  },
  {
    slug: "come-funziona-finanza-agevolata",
    category: "Finanza agevolata",
    q: "Come funziona la finanza agevolata e chi può accedervi?",
    a: "La finanza agevolata è l'insieme di contributi pubblici, fondi perduti, finanziamenti a tasso ridotto e crediti d'imposta che sostengono investimenti aziendali. Possono accedervi imprese già attive e, in molte misure, anche nuove imprese e startup. L'accesso è vincolato a requisiti formali e a un progetto di investimento documentato.",
    detail: [
      "Ogni misura ha una logica precisa: alcune premiano l'innovazione tecnologica, altre l'occupazione, altre la sostenibilità o l'internazionalizzazione. Candidarsi al bando sbagliato è il modo più rapido per perdere tempo e credibilità.",
      "Per questo partiamo dal progetto e non dal bando: definiamo cosa vuoi fare nei prossimi 12-24 mesi e poi cerchiamo lo strumento che finanzia davvero quel percorso, valutando anche la cumulabilità tra più agevolazioni.",
    ],
  },
  {
    slug: "zes-unica-crediti-imposta-mezzogiorno",
    category: "Finanza agevolata",
    q: "Cos'è la ZES Unica e quali vantaggi fiscali offre alle imprese del Sud?",
    a: "La ZES Unica per il Mezzogiorno prevede un credito d'imposta sugli investimenti in beni strumentali per le imprese che operano nelle regioni del Sud, Campania inclusa, insieme a procedure autorizzative semplificate. Il beneficio si calcola in percentuale sull'investimento, con intensità che varia per dimensione d'impresa e area.",
    detail: [
      "Il credito d'imposta è uno strumento potente perché non è a graduatoria: se hai i requisiti e presenti la comunicazione nei tempi previsti, il beneficio è utilizzabile in compensazione.",
      "Gli errori più frequenti riguardano l'ammissibilità dei beni, il calcolo dell'intensità di aiuto e la documentazione tecnica. Sono esattamente i punti su cui una verifica preventiva evita contestazioni future.",
    ],
  },
  {
    slug: "quanto-costa-aprire-attivita",
    category: "Avvio impresa",
    q: "Quanto costa aprire un'attività da zero e quali sono le voci da non sottovalutare?",
    a: "Il costo di apertura dipende dalla forma giuridica e dal settore, ma le voci da mettere sempre in conto sono quattro: costituzione e adempimenti, investimenti iniziali, capitale circolante per i primi 6-12 mesi e costi ricorrenti fissi. È il capitale circolante la voce più sottostimata da chi parte.",
    detail: [
      "Molte nuove attività chiudono non perché non fatturano, ma perché finiscono la liquidità prima di raggiungere il break even. Il piano di cassa mese per mese è più importante del business plan patinato.",
      "Nel percorso di avvio valutiamo anche gli strumenti agevolati dedicati a nuove imprese e giovani imprenditori, che possono coprire una quota significativa dell'investimento iniziale.",
    ],
  },
  {
    slug: "business-plan-startup-cosa-contiene",
    category: "Avvio impresa",
    q: "Serve un business plan per una startup e cosa deve contenere?",
    a: "Sì: serve per decidere, non per fare bella figura. Un business plan utile contiene analisi di mercato e concorrenza, modello di ricavo, struttura dei costi, piano economico-finanziario a 3 anni, piano di cassa mensile del primo anno e piano operativo con responsabilità e scadenze.",
    detail: [
      "Un business plan solido è anche la condizione di accesso a quasi tutte le misure di finanza agevolata e ai finanziamenti bancari: senza numeri coerenti, la pratica si blocca.",
      "Lo costruiamo insieme all'imprenditore, non al posto suo: chi presenta il piano deve saper difendere ogni ipotesi, dai volumi al prezzo medio, davanti a una banca o a una commissione di valutazione.",
    ],
  },
  {
    slug: "errori-nuove-attivita-primi-12-mesi",
    category: "Avvio impresa",
    q: "Quali errori fanno più spesso le nuove attività nei primi 12 mesi?",
    a: "I cinque errori più frequenti sono: nessun controllo della liquidità, prezzi fissati senza calcolare il margine, tutto sulle spalle del titolare, marketing improvvisato senza posizionamento e primi assunti senza ruoli definiti. Sono tutti errori di struttura, non di prodotto, e si correggono prima che diventino costosi.",
    detail: [
      "Nei primi mesi la priorità non è crescere, è capire cosa funziona: quali clienti sono profittevoli, quale canale porta contatti a costo sostenibile, quale prezzo il mercato accetta.",
      "Un check-up trimestrale sui numeri, con tre o quattro indicatori chiave, è di solito sufficiente per intervenire prima che un problema diventi strutturale.",
    ],
  },
  {
    slug: "controllo-di-gestione-piccola-impresa",
    category: "Finanza e controllo",
    q: "Cos'è il controllo di gestione e perché serve anche a una piccola impresa?",
    a: "Il controllo di gestione è il sistema che misura come l'impresa produce margine: costi per prodotto o servizio, marginalità per cliente, andamento della cassa e scostamenti rispetto al budget. Serve anche alle piccole imprese perché permette di decidere su dati aggiornati e non sull'estratto conto.",
    detail: [
      "Non richiede software costosi per partire: bastano un conto economico gestionale mensile, un piano di cassa e tre o quattro KPI scelti in base al settore.",
      "L'obiettivo è arrivare a un cruscotto che l'imprenditore legge in dieci minuti e che dice, ogni mese, dove si guadagna e dove si perde.",
    ],
  },
  {
    slug: "capire-se-azienda-guadagna",
    category: "Finanza e controllo",
    q: "Come capisco se la mia azienda sta guadagnando davvero?",
    a: "Il fatturato non dice se guadagni. Servono tre misure: margine di contribuzione per linea di prodotto o servizio, risultato operativo al netto di tutti i costi fissi e flusso di cassa. Se cresce il fatturato ma non la cassa, il problema è nei prezzi, nei costi o nei tempi di incasso.",
    detail: [
      "Il caso più comune nelle PMI è la crescita che consuma liquidità: più volumi, più magazzino e più crediti verso clienti, con incassi che arrivano dopo i pagamenti ai fornitori.",
      "Analizziamo insieme marginalità e ciclo del circolante, poi interveniamo su leve concrete: listini, mix di vendita, condizioni di pagamento, struttura dei costi.",
    ],
  },
  {
    slug: "differenza-commercialista-consulente-aziendale",
    category: "Metodo",
    q: "Che differenza c'è tra il commercialista e un consulente aziendale?",
    a: "Il commercialista presidia contabilità, dichiarazioni e adempimenti fiscali: guarda soprattutto al passato e alla conformità. Il consulente aziendale lavora sulle decisioni future: strategia, marginalità, organizzazione, persone, marketing e finanza agevolata. Le due figure non si sostituiscono, lavorano bene insieme.",
    detail: [
      "Noi non sostituiamo il tuo commercialista: ci integriamo con lui, condividendo dati e obiettivi, perché la contabilità è la materia prima del controllo di gestione.",
      "Se invece hai bisogno anche della parte contabile e del lavoro, possiamo gestirla internamente: in questo modo hai un solo interlocutore per tutta la filiera.",
    ],
  },
  {
    slug: "consulente-unico-o-piu-professionisti",
    category: "Metodo",
    q: "Meglio un consulente unico o più professionisti separati?",
    a: "Più professionisti separati funzionano se qualcuno coordina le decisioni; senza regia, le indicazioni entrano in conflitto e l'imprenditore diventa il punto di raccordo. Un team integrato con un unico referente riduce tempi, evita decisioni contraddittorie e mantiene una visione comune su finanza, persone, marketing e organizzazione.",
    detail: [
      "È il motivo per cui Idea 360 lavora come squadra: ogni area ha il suo specialista, ma la strategia viene condivisa e portata al cliente da un referente unico che conosce il dossier.",
      "Il risultato pratico è che non devi ripetere la tua storia a cinque interlocutori diversi, e le azioni delle diverse aree si rinforzano invece di annullarsi.",
    ],
  },
  {
    slug: "primi-interventi-accelerare-crescita",
    category: "Metodo",
    q: "Quali sono i primi interventi per accelerare la crescita di un'azienda?",
    a: "Nei primi 90 giorni intervengono quasi sempre tre leve: chiarezza sui numeri (marginalità e cassa), revisione del posizionamento e dei prezzi, definizione di ruoli e processi. Solo dopo ha senso spingere su acquisizione clienti e investimenti: altrimenti si amplifica un modello che perde margine.",
    detail: [
      "Facciamo prima una fotografia dello stato attuale, poi definiamo insieme tre priorità con obiettivi misurabili e responsabili assegnati.",
      "Ogni mese verifichiamo gli scostamenti e correggiamo. È un metodo poco spettacolare ma molto efficace, perché produce risultati verificabili invece di piani rimasti nel cassetto.",
    ],
  },
  {
    slug: "quanto-tempo-per-risultati-consulenza",
    category: "Metodo",
    q: "Quanto tempo serve per vedere i risultati di una consulenza?",
    a: "I primi effetti su organizzazione e controllo dei numeri si vedono in 30-60 giorni. Gli impatti su marginalità e liquidità richiedono in genere 3-6 mesi, perché dipendono da prezzi, mix di vendita e tempi di incasso. Bandi e finanza agevolata seguono invece i tempi degli enti erogatori.",
    detail: [
      "Fissiamo obiettivi e indicatori all'inizio del percorso, così i progressi sono misurabili e non opinabili.",
      "Se un'azione non produce l'effetto atteso entro la finestra stabilita, la cambiamo: non ha senso insistere su una leva che i dati dicono non funzionare.",
    ],
  },
  {
    slug: "assumere-primo-dipendente-costi",
    category: "Persone e lavoro",
    q: "Come si assume il primo dipendente e quanto costa realmente?",
    a: "Il costo reale di un dipendente è il lordo aziendale: retribuzione, contributi, TFR, ferie, tredicesima e oneri accessori. In genere è sensibilmente superiore alla retribuzione netta percepita. Prima di assumere serve verificare il CCNL applicabile, la mansione, il tipo di contratto e gli eventuali incentivi all'occupazione.",
    detail: [
      "La scelta del contratto e del livello incide su costo, flessibilità e possibilità di accedere a sgravi contributivi, particolarmente rilevanti nel Mezzogiorno e per alcune categorie di lavoratori.",
      "Gestiamo l'intero processo: definizione del ruolo, selezione, inquadramento, adempimenti e gestione mensile delle paghe.",
    ],
  },
  {
    slug: "formazione-personale-fondi-interprofessionali",
    category: "Persone e lavoro",
    q: "Come si finanzia la formazione del personale senza costi per l'azienda?",
    a: "Le imprese che versano il contributo obbligatorio per la formazione possono aderire a un fondo interprofessionale e recuperare quelle risorse sotto forma di piani formativi finanziati. Esistono inoltre bandi regionali dedicati allo sviluppo delle competenze delle PMI, che coprono in tutto o in parte i costi dei percorsi.",
    detail: [
      "L'adesione al fondo è gratuita e si effettua con una semplice indicazione nel flusso contributivo mensile; da quel momento le risorse accantonate diventano utilizzabili per la formazione dei tuoi dipendenti.",
      "Progettiamo i piani formativi in base a competenze reali da colmare, non a cataloghi standard: formazione tecnica, manageriale, sicurezza e digitale.",
    ],
  },
  {
    slug: "marketing-ristorante-struttura-ricettiva",
    category: "Marketing",
    q: "Come si struttura il marketing di un ristorante o di una struttura ricettiva?",
    a: "Si parte dal posizionamento: a chi ti rivolgi, con quale proposta e a quale prezzo. Poi si costruiscono i canali che generano prenotazioni dirette (sito, Google Business Profile, recensioni, social, email) per ridurre la dipendenza dalle piattaforme di intermediazione e dal loro costo di commissione.",
    detail: [
      "Nei settori ristorazione, hotellerie e esperienze turistiche il margine si difende soprattutto spostando quota di prenotazioni dal canale intermediato al canale diretto.",
      "Misuriamo costo per prenotazione, valore medio dello scontrino e tasso di ritorno del cliente: sono i tre numeri che dicono se il marketing sta funzionando.",
    ],
  },
  {
    slug: "consulenza-per-startup-idea-a-business",
    category: "Avvio impresa",
    q: "Ho un'idea ma non un'azienda: da dove comincio?",
    a: "Si comincia validando l'idea prima di investire: chi è il cliente, quanto è disposto a pagare, quanto costa raggiungerlo. Poi si scelgono forma giuridica e regime fiscale, si costruisce il piano economico e si verificano le agevolazioni disponibili per nuove imprese. Solo dopo si spende.",
    detail: [
      "La validazione può richiedere poche settimane e costa una frazione di quello che costerebbe scoprire l'errore dopo l'apertura.",
      "Accompagniamo chi parte da zero fino ai primi mesi di attività, con un referente unico per adempimenti, numeri, persone e comunicazione.",
    ],
  },
];

export const getFaqBySlug = (slug) => FAQS.find((f) => f.slug === slug);

export const faqPageJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
